import { isEmpty, reject } from "ramda"

export const paramsToQueryString = (params: Record<string, string>): string => {
  const validParams = reject(isEmpty)(params)
  return new URLSearchParams(validParams).toString()
}